import translationar from './translation-ar.json';
import translationcs from './translation-cs.json';
import translationde from './translation-de.json';
import translationen from './translation-en.json';
import translationes from './translation-es.json';
import translationfr from './translation-fr.json';
import translationit from './translation-it.json';
import translationja from './translation-ja.json';
import translationpl from './translation-pl.json';
import translation from './translation.json';

// webpack transforms these JSON imports to resource URLs, so we cast our export accordingly here.
const i18nEndPointMap: Record<string, string> = {
  'translation-ar.json': translationar as unknown as string,
  'translation-cs.json': translationcs as unknown as string,
  'translation-de.json': translationde as unknown as string,
  'translation-en.json': translationen as unknown as string,
  'translation-es.json': translationes as unknown as string,
  'translation-fr.json': translationfr as unknown as string,
  'translation-it.json': translationit as unknown as string,
  'translation-ja.json': translationja as unknown as string,
  'translation-pl.json': translationpl as unknown as string,
  'translation.json': translation as unknown as string
}

export default i18nEndPointMap;
